(function() {
  'use strict';
  console.log('[Quiz] quiz.js yüklendi');
  function getEl(id) { return document.getElementById(id); }
  let overlay, modal, progressBar, closeBtn, backBtn, nextBtn, resultCloseBtn;

  /* Sayfa yüklendiğinde form kontrolü */
  (function checkQuizFormOnLoad() {
    var form = document.getElementById('quizContactForm');
    console.log('[Quiz] Sayfa yüklendi - Contact Form:', !!form);
    if (form) console.log('[Quiz] Form action:', form.action);
  })();

  /* Shopify: quiz overlay+modal body sonuna taşı */
  (function moveQuizToBody() {
    var o = getEl('quizOverlay');
    var m = getEl('quizModal');
    var parent = o && o.parentElement;
    if (o && m && parent && parent !== document.body) {
      document.body.appendChild(o);
      o.appendChild(m); /* modal overlay içinde = overlay üstünde render */
    }
  })();

  let step = 0;
  let contactSubmitted = false;
  let quizData = {
    name: '',
    email: '',
    goals: [],
    sleepQuality: '',
    stressLevel: '',
    skinConcerns: [],
    immuneSupport: ''
  };

  const RECOMMENDATIONS = {
    balance: {
      name: 'Gleemy Balance',
      description: 'Senin için mükemmel! C vitamini ile bağışıklık sistemini güçlendir, günlük enerjini artır.',
      benefits: ['Günlük C vitamini desteği', 'Bağışıklık sistemi güçlendirme', 'Enerji ve canlılık'],
      url: ''
    },
    dream: {
      name: 'Gleemy Dream',
      description: 'Senin için ideal! Magnezyum ve L-Theanine ile mışıl mışıl uyuyacaksın.',
      benefits: ['Magnezyum ile rahat uyku', 'L-Theanine ile zihinsel dinginlik', 'Doğal uyku düzeni desteği'],
      url: ''
    },
    glow: {
      name: 'Gleemy Glow',
      description: 'Senin için harika! Biyotin ve Kolajen ile cildinin ışıltısını artır.',
      benefits: ['Biyotin ile saç, cilt ve tırnak desteği', 'Kolajen ile içten dışa ışıltı', 'Anti-aging etkisi'],
      url: ''
    },
    package: {
      name: 'Gleemy Üçlü Paket',
      description: 'Senin için en iyi çözüm! Hem bağışıklığını güçlendir, hem rahat uyu, hem de cildin ışıldasın. 3\'lü pakette %20 indirim!',
      benefits: ['Balance: Günlük C vitamini desteği', 'Dream: Rahat uyku için özel formül', 'Glow: Cilt sağlığı için Kolajen & Biyotin'],
      url: ''
    }
  };

  function openQuiz() {
    overlay = getEl('quizOverlay');
    modal = getEl('quizModal');
    if (!overlay || !modal) return;
    step = 0;
    quizData = { name: '', email: '', goals: [], sleepQuality: '', stressLevel: '', skinConcerns: [], immuneSupport: '' };
    contactSubmitted = false;
    overlay.classList.add('open');
    modal.classList.add('open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    progressBar = getEl('quizProgressBar');
    backBtn = getEl('quizBackBtn');
    nextBtn = getEl('quizNextBtn');
    showStep(0);
    resetOptions();
    const nameEl = getEl('quizName');
    const emailEl = getEl('quizEmail');
    if (nameEl) nameEl.value = '';
    if (emailEl) emailEl.value = '';
  }

  function closeQuiz() {
    const o = getEl('quizOverlay');
    const m = getEl('quizModal');
    if (o) {
      o.classList.remove('open');
      o.setAttribute('aria-hidden', 'true');
    }
    if (m) m.classList.remove('open');
    document.body.style.overflow = '';
  }

  function showStep(s) {
    step = s;
    document.querySelectorAll('.quiz-step').forEach(el => el.classList.remove('active'));
    const el = document.querySelector('.quiz-step[data-step="' + s + '"]');
    if (el) el.classList.add('active');
    const pb = getEl('quizProgressBar');
    if (pb) pb.style.width = ((s + 1) / 7) * 100 + '%';
    const nav = getEl('quizNav');
    if (nav) nav.style.display = s === 6 ? 'none' : 'flex';
    const bb = getEl('quizBackBtn');
    if (bb) bb.style.display = s > 0 && s < 6 ? 'block' : 'none';
    const nb = getEl('quizNextBtn');
    if (nb) {
      nb.textContent = s === 5 ? 'Sonuçları Gör' : 'Devam Et';
      nb.type = 'button';
    }
    updateNextState();
    if (s === 6) renderResult();
  }

  function resetOptions() {
    document.querySelectorAll('.quiz-options button').forEach(btn => {
      btn.classList.remove('selected');
      if (btn.dataset.type === 'multi') return;
    });
  }

  function updateNextState() {
    const nb = getEl('quizNextBtn');
    if (nb) nb.disabled = !isStepValid();
  }

  function isStepValid() {
    switch (step) {
      case 0:
        const name = (getEl('quizName')?.value || '').trim();
        const email = (getEl('quizEmail')?.value || '').trim();
        return name.length > 0 && email.length > 0 && email.includes('@');
      case 1: return quizData.goals.length > 0;
      case 2: return quizData.sleepQuality !== '';
      case 3: return quizData.stressLevel !== '';
      case 4: return true;
      case 5: return quizData.immuneSupport !== '';
      default: return true;
    }
  }

  function calculateRecommendation() {
    let balanceScore = 0, dreamScore = 0, glowScore = 0;
    if (quizData.goals.includes('immunity')) balanceScore += 2;
    if (quizData.goals.includes('sleep')) dreamScore += 2;
    if (quizData.goals.includes('skin')) glowScore += 2;
    if (quizData.goals.includes('energy')) balanceScore += 1;
    if (['poor', 'fair'].includes(quizData.sleepQuality)) dreamScore += 2;
    if (['high', 'very-high'].includes(quizData.stressLevel)) { dreamScore += 1; balanceScore += 1; }
    if (quizData.skinConcerns.length > 0) glowScore += 2;
    if (quizData.immuneSupport === 'yes') balanceScore += 2;

    const scores = [
      { score: balanceScore, type: 'balance' },
      { score: dreamScore, type: 'dream' },
      { score: glowScore, type: 'glow' }
    ].sort((a, b) => b.score - a.score);
    const top = scores.filter(s => s.score > 0);
    if (top.length >= 2 && top[0].score - top[1].score <= 1) return 'package';
    if (balanceScore >= dreamScore && balanceScore >= glowScore) return 'balance';
    if (dreamScore >= glowScore) return 'dream';
    return 'glow';
  }

  function buildContactBody() {
    var rec = calculateRecommendation();
    return JSON.stringify({
      name: quizData.name,
      email: quizData.email,
      goals: quizData.goals,
      sleepQuality: quizData.sleepQuality,
      stressLevel: quizData.stressLevel,
      skinConcerns: quizData.skinConcerns,
      immuneSupport: quizData.immuneSupport,
      recommendation: rec
    });
  }

  function submitContactFormAjax() {
    if (contactSubmitted) {
      console.log('[Quiz] Contact zaten gönderildi, atlanıyor');
      return;
    }
    var form = document.getElementById('quizContactForm');
    if (!form) {
      console.error('[Quiz] Contact form bulunamadı');
      return;
    }
    var name = (quizData.name || '').trim();
    var email = (quizData.email || '').trim();
    if (!email || !email.includes('@')) {
      console.error('[Quiz] Geçersiz email');
      return;
    }
    var nameEl = getEl('quizContactName');
    var emailEl = getEl('quizContactEmail');
    var bodyEl = getEl('quizContactBody');
    if (nameEl) nameEl.value = name;
    if (emailEl) emailEl.value = email;
    if (bodyEl) bodyEl.value = buildContactBody();

    console.log('[Quiz] Contact form dolduruluyor:', { name: name, email: email ? '***' : '' });
    contactSubmitted = true;

    function doAjaxSubmit() {
      var formData = new FormData(form);
      console.log('[Quiz] AJAX submit başlatılıyor, URL:', form.action, 'FormData keys:', Array.from(formData.keys()));
      fetch(form.action, {
        method: 'POST',
        body: formData,
        credentials: 'same-origin'
      }).then(function(response) {
        console.log('[Quiz] AJAX submit yanıtı:', response.status, response.statusText);
        return response.text();
      }).then(function(html) {
        if (html.indexOf('form-success') !== -1) {
          console.log('[Quiz] Contact form başarıyla gönderildi');
          showStep(6);
        } else {
          console.warn('[Quiz] Contact form yanıtı - form-success bulunamadı, html önizleme:', html.substring(0, 300));
          contactSubmitted = false;
          showStep(6);
        }
      }).catch(function(err) {
        console.error('[Quiz] AJAX submit hatası:', err);
        contactSubmitted = false;
        showStep(6);
      });
    }

    if (window.Shopify && window.Shopify.captcha && typeof window.Shopify.captcha.protect === 'function') {
      console.log('[Quiz] Shopify.captcha.protect ile CAPTCHA bekleniyor');
      window.Shopify.captcha.protect(form, doAjaxSubmit);
    } else {
      console.log('[Quiz] CAPTCHA yok, direkt AJAX submit');
      doAjaxSubmit();
    }
  }

  function renderResult() {
    const rec = RECOMMENDATIONS[calculateRecommendation()];
    const firstName = (quizData.name.split(' ')[0] || '') || 'Sen';
    const rt = getEl('quizResultTitle');
    if (rt) rt.textContent = 'Mükemmel ' + firstName + '! 🎉';
    const rn = getEl('quizResultName');
    if (rn) rn.textContent = rec.name;
    const rd = getEl('quizResultDesc');
    if (rd) rd.textContent = rec.description;
    const ul = getEl('quizResultBenefits');
    if (ul) ul.innerHTML = rec.benefits.map(b => '<li>' + b + '</li>').join('');
    const cta = getEl('quizResultCta');
    if (cta) {
      const resultUrl = getEl('quizModal')?.dataset?.resultUrl || '';
      cta.href = resultUrl || '/collections/all';
    }
  }

  function goNext() {
    if (step === 0) {
      quizData.name = (getEl('quizName')?.value || '').trim();
      quizData.email = (getEl('quizEmail')?.value || '').trim();
    }
    if (step === 5) {
      showStep(6);
    } else {
      showStep(step + 1);
    }
  }

  function goBack() {
    if (step > 0) showStep(step - 1);
  }

  document.addEventListener('click', function(e) {
    if (e.target.closest('#quizCloseBtn')) closeQuiz();
    /* Overlay tıklanınca kapat - modal/quiz-inner tıklanınca KAPATMA */
    if (e.target.closest('#quizOverlay') && !e.target.closest('#quizModal')) closeQuiz();
    if (e.target.closest('#quizBackBtn')) goBack();
    if (e.target.closest('#quizNextBtn') && isStepValid()) {
      if (step === 5) {
        e.preventDefault();
        console.log('[Quiz] Step 5 - Contact form AJAX submit tetikleniyor');
        submitContactFormAjax();
      } else {
        goNext();
      }
    }
    if (e.target.closest('#quizResultClose')) closeQuiz();
  });

  var qn = getEl('quizName');
  var qe = getEl('quizEmail');
  if (qn) qn.addEventListener('input', updateNextState);
  if (qe) qe.addEventListener('input', updateNextState);

  /* Event delegation: option butonları - Shopify'da DOM yapısı farklı olabilir */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('#quizModal .quiz-options button');
    if (!btn) return;
    var stepEl = btn.closest('.quiz-step');
    if (!stepEl) return;
    var stepNum = parseInt(stepEl.getAttribute('data-step'), 10);
    var v = btn.getAttribute('data-value');
    if (!v) return;

    if (stepNum === 1) {
      var idx = quizData.goals.indexOf(v);
      if (idx >= 0) quizData.goals.splice(idx, 1);
      else quizData.goals.push(v);
      btn.classList.toggle('selected', quizData.goals.indexOf(v) >= 0);
      updateNextState();
    } else if (stepNum === 2) {
      [].forEach.call(document.querySelectorAll('.quiz-step[data-step="2"] .quiz-options button'), function(b) { b.classList.remove('selected'); });
      btn.classList.add('selected');
      quizData.sleepQuality = v;
      updateNextState();
    } else if (stepNum === 3) {
      [].forEach.call(document.querySelectorAll('.quiz-step[data-step="3"] .quiz-options button'), function(b) { b.classList.remove('selected'); });
      btn.classList.add('selected');
      quizData.stressLevel = v;
      updateNextState();
    } else if (stepNum === 4) {
      var idx = quizData.skinConcerns.indexOf(v);
      if (idx >= 0) quizData.skinConcerns.splice(idx, 1);
      else quizData.skinConcerns.push(v);
      btn.classList.toggle('selected', quizData.skinConcerns.indexOf(v) >= 0);
    } else if (stepNum === 5) {
      [].forEach.call(document.querySelectorAll('.quiz-step[data-step="5"] .quiz-options button'), function(b) { b.classList.remove('selected'); });
      btn.classList.add('selected');
      quizData.immuneSupport = v;
      updateNextState();
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && getEl('quizModal')?.classList.contains('open')) closeQuiz();
  });

  window.openQuizModal = openQuiz;

  document.body.addEventListener('click', function(e) {
    const trigger = e.target.closest('[data-quiz-open], .quiz-open-trigger');
    if (trigger) {
      e.preventDefault();
      openQuiz();
    }
  });
})();
